import './YesNoButton.css';

const YesNoButton = ({ id, value, active, onClick, label, icon }) => (
  <button
    className={`${value} ${active ? `active-${value}` : ''}`}
    onClick={() => onClick(id, value)}
  >
    {icon && <span className="button-icon">{icon}</span>}
    {label}
  </button>
);

export default YesNoButton;
